import {
  TOGGLE_COLLABORATE_WIDGET,
  BULK_CHANGE_COLLAB_STATE_ROUTINE,
  CHANGE_COLLAB_STATE_ROUTINE,
  HANDLE_STATUS_CHANGED,
} from "constants/ActionTypes";
import { createAction } from "@reduxjs/toolkit";

export const toggleCollaborateWidget = (index: number, post: unknown) => ({
  type: TOGGLE_COLLABORATE_WIDGET,
  index,
  post,
});

export const bulkChangeCollabState = createAction(
  BULK_CHANGE_COLLAB_STATE_ROUTINE.TRIGGER,
  function prepare(
    postIds: string[],
    postType: string,
    key: string,
    callback?: () => void
  ) {
    return {
      payload: {
        postIds,
        postType,
        key,
        callback,
      },
    };
  }
);

export const changeCollabState = createAction(
  CHANGE_COLLAB_STATE_ROUTINE.TRIGGER,
  function prepare(
    postIds: string[],
    postType: string,
    key: string,
    callback: (ap?: string) => void,
    // Board drag-and-drop opts out of the per-change full reload (it moves the
    // card optimistically and the SUCCESS reducer patches the slice). Other
    // callers omit this and keep the reload.
    options?: { skipReload?: boolean }
  ) {
    return {
      payload: {
        postIds,
        postType,
        key,
        callback,
        options,
      },
    };
  }
);

export const handleStatusChanged = createAction(
  HANDLE_STATUS_CHANGED,
  function prepare(postType: string, post: unknown) {
    return {
      payload: { postType, post },
    };
  }
);
